import { CloseIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, IconButton, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';
import { useSkuUpsertModal } from '@pages/UploadSellout/hooks/state/useSkuUpsertModal';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { requiredFields } from './const';
import SectionBody from './section/body';
import { useDataKonversi } from '@pages/UploadSellout/hooks/state/useDataKonversi';
import { useSnackbarNotification } from '@store/snackbarNotification';

export default function SkuUpsertModal() {
    const modalWidth = '800px';
    const { onChangeSnackbarNotification } = useSnackbarNotification();
    const [localForm, setLocalForm] = useState({});
    const [isSynced, setIsSynced] = useState(true);
    const selectedTimeUploadType = JSON.parse(localStorage.getItem('selectedTimeUploadType'));
    const modalTitleOpt = selectedTimeUploadType === 'daily' ? 'Harian' : 'Bulanan';
    const { isOpen, close, reset, form, setFields, mode } = useSkuUpsertModal();
    const { editData, moveData, addData } = useDataKonversi();

    const handleClose = () => {
        close();
        reset();
    };

    const isInvalid = requiredFields.some((field) => !localForm[field]);
    const handleSubmit = () => {
        const isEdit = mode === 'edit';
        const recordId = form?.id;

        const toInsertData = {
            ...localForm,
            id: isEdit ? recordId : crypto.randomUUID(),
        };

        setFields(localForm);

        if (isEdit) {
            editData(recordId, toInsertData);
            moveData(recordId, 'success');
        } else {
            addData(toInsertData);
        }

        onChangeSnackbarNotification({
            status: 'success',
            title: 'Berhasil Menambahkan SKU',
            duration: 3,
            description: (
                <>
                    SKU <b>{localForm?.name}</b> telah {isEdit ? 'diedit' : 'ditambahkan'}
                </>
            ),
        });

        handleClose();
    };

    const renderModalHeader = () => {
        return (
            <Flex gap={'1rem'} justifyContent={'space-between'} mb={'32px'}>
                <Text fontWeight={'700'} fontSize={'24px'}>
                    {mode === 'edit' ? `Edit SKU - ${modalTitleOpt}` : `Tambah SKU - ${modalTitleOpt}`}
                </Text>

                <IconButton
                    aria-label="Close Modal"
                    onClick={handleClose}
                    variant={'unstyled'}
                    icon={<CloseIcon color={'semantic.900'} />}
                />
            </Flex>
        );
    };

    const renderModalFooter = () => {
        return (
            <Flex gap={'1rem'} justifyContent={'space-between'} alignItems={'center'}>
                <Link to={`${window.location.origin}/upload-mapping-v2`} target="_blank" rel="noopener noreferrer">
                    <Button variant={'unstyled'} textDecor={'underline'} fontWeight={'700'}>
                        Buka Product Mapping
                    </Button>
                </Link>

                <Flex gap={'12px'}>
                    <Button onClick={handleClose} variant={'outline'} w={'158px'}>
                        Batal
                    </Button>
                    <Button onClick={handleSubmit} w={'158px'} disabled={isInvalid || !isSynced}>
                        Simpan
                    </Button>
                </Flex>
            </Flex>
        );
    };

    useEffect(() => {
        setLocalForm(form);
    }, [form]);

    return (
        <ModalTemplate width={modalWidth} isOpen={isOpen} onClose={handleClose} isClosebyOverlayClick={false}>
            <Box p={'24px'}>
                {renderModalHeader()}
                <SectionBody localForm={localForm} setLocalForm={setLocalForm} setIsSynced={setIsSynced} />
                {renderModalFooter()}
            </Box>
        </ModalTemplate>
    );
}
